// extracted by mini-css-extract-plugin
export default {"settings":"Settings_settings__dahlt","settings__title":"Settings_settings__title__TM3XT","settings__tab-names-item":"Settings_settings__tab-names-item__W-Ldv"};